enum FitAssistantStep {
  Mounting = 'mounting',
  RackMounting = 'rackmounting',
  Make = 'make',
  Model = 'model',
  Year = 'year',
  Variation = 'variation',
  OtherFits = 'otherfits',
  NoFits = 'nofits',
  RoofRacks = 'roofracks',
  VanSize = 'vansize',
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed',
  ConfirmedNoRacks = 'confirmednoracks',
  CarSeatFit = 'carseatfit',
  VehicleInfoNeeded = 'vehicleinfoneeded',
}

export default FitAssistantStep;
